module.exports = __webpack_public_path__ + "img/branch-address.c7b540b5.png";